import React from "react";
import { CustomInput } from "elements/DEPRECATED_elements";

const CustomSelect = React.forwardRef((props, ref) => {
  return (
    <CustomInput
      select
      SelectProps={{
        native: true,
      }}
      {...props}
    >
      {props.children}
    </CustomInput>
  );
});

export default CustomSelect;
